import { render, staticRenderFns } from "./productupdatejd.vue?vue&type=template&id=47f62e28&scoped=true&"
import script from "./productupdatejd.vue?vue&type=script&lang=js&"
export * from "./productupdatejd.vue?vue&type=script&lang=js&"
import style0 from "./productupdatejd.vue?vue&type=style&index=0&id=47f62e28&prod&lang=scss&"
import style1 from "./productupdatejd.vue?vue&type=style&index=1&id=47f62e28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f62e28",
  null
  
)

export default component.exports